import React, { Component } from "react"
import { NamespacesConsumer as I18n } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import validator from "validator"
import config from "../config"
import AWS from "aws-sdk"

//component
import { NotificationManage } from "./NotificationManage"

//material ui
import PropTypes from "prop-types"
import Button from "@material-ui/core/Button"
import FormControl from "@material-ui/core/FormControl"
import TextField from "@material-ui/core/TextField"
import withStyles from "@material-ui/core/styles/withStyles"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import CircularProgress from "@material-ui/core/CircularProgress"
import Avatar from "@material-ui/core/Avatar"
import Typography from "@material-ui/core/Typography"
import CallIcon from "@material-ui/icons/Call"
import { ContactUsStyle } from "../containers/Style/ContactUsStyle"

class ContactUs extends Component {
	constructor(props) {
		super(props)
		this.state = {
			To: "support@mixedmodel.academy",
			from:
				Object.keys(this.props.user).length === 0
					? ""
					: this.props.userInfo.email,
			subject: "",
			contentUser: "",
			erroremail: false,
			isLoading: false
		}
	}
	componentDidMount() {
		this.setState({
			from:
				Object.keys(this.props.user).length === 0
					? ""
					: this.props.userInfo.email
		})
	}
	UNSAFE_componentWillReceiveProps() {
		this.setState({
			from:
				Object.keys(this.props.user).length === 0
					? ""
					: this.props.userInfo.email
		})
	}
	handleSubmit = (event, t) => {
		event.preventDefault()
		this.setState({ isLoading: true })
		const { from, subject, contentUser } = this.state
		let params = {
			Destination: {
				ToAddresses: ["support@mixedmodel.academy"]
			},
			Message: {
				Body: {
					Html: {
						Charset: "UTF-8",
						Data: `<b>From:</b> ${from} 
						<br><b>Subject: </b> ${subject} 
						<br><br>  
						&nbsp;&nbsp;<b>Message</b> 
						<br> 
						&nbsp;&nbsp;${contentUser}`
					}
				},
				Subject: {
					Charset: "UTF-8",
					Data: `Contact Us : ${subject}`
				}
			},
			Source: "support@mixedmodel.academy"
		}
		const {
			AccessKeyId,
			SecretKey,
			SessionToken
		} = this.props.user.data.Credentials
		const sendPromise = new AWS.SES({
			region: config.SES.REGION,
			accessKeyId: AccessKeyId,
			secretAccessKey: SecretKey,
			sessionToken: SessionToken
		})
			.sendEmail(params)
			.promise()

		sendPromise
			.then(data => {
				NotificationManage(
					"success",
					`${t("NotificationManager.Report")}`,
					`${t("NotificationManager.status.success")}`
				)
				this.setState({ isLoading: false })
				this.props.handleDialogClose()
			})
			.catch(err => {
				NotificationManage(
					"error",
					`${t("NotificationManager.Project.try")}`,
					`${t("NotificationManager.status.Error")}`
				)
				this.setState({ isLoading: false })
				this.props.handleDialogClose()
			})
		this.setState({
			To: "support@mixedmodel.academy",
			from:
				Object.keys(this.props.user).length === 0
					? ""
					: this.props.userInfo.email,
			subject: "",
			contentUser: "",
			erroremail: false
		})
	}
	validate = () => {
		if (
			this.state.contentUser.length === 0 ||
			this.state.contentUser.trim() === "" ||
			this.state.from === "" ||
			this.state.subject === "" ||
			!validator.isEmail(this.state.from)
		) {
			return true
		}
		return false
	}
	handleChange = event => {
		this.setState({
			[event.target.id]: event.target.value
		})
	}
	render() {
		const { classes, handleDialogClose, Open } = this.props
		const { To, from, contentUser, erroremail, subject } = this.state
		return (
			<I18n>
				{t => {
					return (
						<Dialog
							open={Open}
							onClose={handleDialogClose}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description"
						>
							<DialogContent className="Dialog">
								<div className="feedback_container1">
									<div className="formatcontent1">
										<Avatar className={classes.avatar}>
											<CallIcon />
										</Avatar>
									</div>
									<div className="formatcontent1">
										<Typography
											variant="h5"
											component="h3"
											style={{
												fontSize: 18,
												fontFamily: "Roboto, sans-serif"
											}}
										>
											{t("NavBarDesktop.NavBarDesktopContactUs")}
										</Typography>
									</div>
									<form className={classes.form}>
										<FormControl
											margin="normal"
											style={{ marginTop: "8px" }}
											fullWidth
										>
											<TextField
												multiline
												InputProps={{
													readOnly: true
												}}
												id="To"
												label={t("Report.To")}
												value={To}
												onChange={this.handleChange}
											/>
										</FormControl>
										<FormControl
											margin="normal"
											style={{ marginTop: "8px" }}
											fullWidth
										>
											<TextField
												error={erroremail}
												multiline
												id="from"
												label={t("Report.From")}
												placeholder={t("login.eg")}
												value={from}
												onChange={this.handleChange}
												InputProps={{
													readOnly:
														Object.keys(this.props.user).length !== 0
															? true
															: false
												}}
											/>
										</FormControl>
										<FormControl
											margin="normal"
											style={{ marginTop: "8px" }}
											fullWidth
										>
											<TextField
												multiline
												id="subject"
												label={t("Report.Subject")}
												placeholder={`${t("button.enter")} ${t(
													"Report.Subject"
												)}`}
												value={subject}
												onChange={this.handleChange}
											/>
										</FormControl>
										<FormControl margin="normal" fullWidth>
											<TextField
												autoFocus
												variant="outlined"
												InputLabelProps={{
													shrink: true
												}}
												multiline
												rows="8"
												id="contentUser"
												label={t("Report.Message")}
												placeholder={t("community.what")}
												value={contentUser}
												onChange={this.handleChange}
											/>
										</FormControl>
										<div className={classes.root}>
											<div className={classes.wrapper}>
												<Button
													aria-label="handleSubmit"
													disabled={this.validate()}
													fullWidth
													className={
														this.state.isLoading || this.validate()
															? classes.disableButt
															: classes.summitButt
													}
													onClick={event => this.handleSubmit(event, t)}
												>
													{t("button.buttonSend")}
												</Button>
												{this.state.isLoading && (
													<CircularProgress
														size={24}
														className={classes.buttonProgress}
													/>
												)}
											</div>
										</div>
									</form>
								</div>
							</DialogContent>
						</Dialog>
					)
				}}
			</I18n>
		)
	}
}
ContactUs.propTypes = {
	classes: PropTypes.object.isRequired
}
function mapStateToProps(reduxState) {
	return {
		user: reduxState.UserReducer.user,
		userInfo: reduxState.UserReducer.userInfo
	}
}
export default compose(
	withStyles(ContactUsStyle),
	connect(mapStateToProps, null)
)(ContactUs)
